import script from "./ScoreList.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreList.vue?vue&type=script&setup=true&lang=js"

import "./ScoreList.vue?vue&type=style&index=0&id=36996ba0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36996ba0"]])

export default __exports__